import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideFvElements = document.getElementsByClassName('splide__fv splide'); // right-image

/**
 * 指定したスライド内のすべての対象要素に is-active クラスを付与または削除する関数
 * @param {Element} slide - 対象のスライド
 * @param {Array} selectors - is-active クラスを付与したい要素のセレクタの配列
 * @param {boolean} add - true: クラスを追加, false: クラスを削除
 */
function toggleActiveClass(slide, selectors, add) {
  // クローン要素はスキップ
  if (slide.classList.contains('splide__slide--clone')) {
    return;
  }


  selectors.forEach(selector => {
    const elements = slide.querySelectorAll(selector);
    elements.forEach(element => {
      if (add) {
        element.classList.add('is-active');
      } else {
        element.classList.remove('is-active');
      }
    });
  });
}

if (splideFvElements.length) {
  let fvSlides = [];

  // 付与・削除したい対象要素のセレクタを変数にまとめる
  const targetSelectors = ['.p-img__fv__picture', '.p-img__fv', '.c-splide__left'];

  // FVスライダーの初期化
  for (let i = 0; i < splideFvElements.length; i++) {
    let fvSlide = new Splide(splideFvElements[i], {
      // ここにオプションを設定
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: true,
      autoplay: true,
      speed: 800,
      pauseOnHover: false,
      interval: 8000,
      breakpoints: {
        1025: {
        }
      }
    });

    // スライダーの初期化が完了したら最初のスライドに is-active クラスを追加
    fvSlide.on('mounted', function () {
      let activeSlide = fvSlide.Components.Slides.getAt(fvSlide.index).slide;
      toggleActiveClass(activeSlide, targetSelectors, true);
    });

    // スライドのアクティブ状態変更時の処理
    fvSlide.on('move', function (newIndex) {
      // すべてのスライドを取得
      let slides = splideFvElements[i].querySelectorAll('.splide__slide');

      // すべてのスライドから is-active クラスを削除
      slides.forEach(slide => {
        toggleActiveClass(slide, targetSelectors, false);
      });

      // 新しくアクティブになったスライドに is-active クラスを追加
      let activeSlide = fvSlide.Components.Slides.getAt(fvSlide.index).slide;
      toggleActiveClass(activeSlide, targetSelectors, true);
    });

    // スライダーをマウント
    fvSlide.mount();

    fvSlides.push(fvSlide);
  }
}

const splideFvTextElements = document.getElementsByClassName('splide__fv-text splide'); // right-image
if (splideFvTextElements.length) {

  // FVスライダーの初期化
  for (let i = 0; i < splideFvTextElements.length; i++) {
    let fvTextSlide = new Splide(splideFvTextElements[i], {
      // ここにオプションを設定
      type: 'loop',
      rewind: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      speed: 800,
      pauseOnHover: false,
      interval: 8000,
      autoScroll: {
        speed: .5
      },
      breakpoints: {
        1025: {
        }
      }
    });

    fvTextSlide.mount({ AutoScroll });
    // fvTextSlide.mount();
  }
}

const splidePcElements = document.getElementsByClassName('splide__pc splide');
if (splidePcElements.length) {
  for (let i = 0; i < splidePcElements.length; i++) {
    let pcSlide = new Splide(splidePcElements[i], {
      type: 'loop',
      rewind: true,
      arrows: false,
      pagination: false,
      autoplay: false,
      speed: 800,
      pauseOnHover: false,
      gap: 32,
      interval: 8000,
      autoScroll: {
        speed: .5
      },
      breakpoints: {
        1025: {
        }
      }
    })

    pcSlide.mount({ AutoScroll });
  }
}